import { render, staticRenderFns } from "./TaxView.vue?vue&type=template&id=546a6cf3&"
import script from "./TaxView.vue?vue&type=script&lang=js&"
export * from "./TaxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports